var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import { getPreferredLanguage } from "../../../helpers";
import { generateHash, generateMinifiedQuery } from "../../../Graphql/hash";
var tveProviderListQuery = "query ($device: Device!, $domain: String, $siteId: String, $country: String, $language: String) {\n  bootstrap(device: $device, domain: $domain, siteId: $siteId, country: $country, language: $language) {\n    appcmsPlatform {\n      tveSettings {\n        providers\n        {\n          identifier\n          imageUrl\n          logoUrl\n          title\n          fwIdentifier\n          }\n      }\n    }\n  }\n}";
var minifiedTveQuery = generateMinifiedQuery(tveProviderListQuery);
var minifiedTveQuerySHA = generateHash(minifiedTveQuery);
export function getTveProviderList() {
    var _this = this;
    var _a, _b, _c;
    var baseUrl = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.apiConfig) === null || _c === void 0 ? void 0 : _c.apiBaseCachedUrl;
    var endpoint = "".concat(baseUrl, "/graphql");
    var variables = {
        "domain": location.host,
        "device": "WEB",
        "country": null,
        "language": getPreferredLanguage() || 'en'
    };
    return axios.get(endpoint + '?extensions={"persistedQuery":{"version":1,"sha256Hash":' + JSON.stringify(minifiedTveQuerySHA) + '}}&variables=' + JSON.stringify(variables))
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = response.data;
                    if (!data.errors) return [3 /*break*/, 3];
                    if (!(data && data.errors && data.errors[0] && data.errors[0].message && data.errors[0].message === "PersistedQueryNotFound")) return [3 /*break*/, 2];
                    return [4 /*yield*/, cacheTveProviderList()];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [3 /*break*/, 4];
                case 3: return [2 /*return*/, data];
                case 4: return [2 /*return*/];
            }
        });
    }); })
        .catch(function (err) { return console.log("Error: ".concat(err), "error"); });
}
var cacheTveProviderList = function () {
    var _a, _b, _c;
    var baseUrl = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.apiConfig) === null || _c === void 0 ? void 0 : _c.apiBaseCachedUrl;
    var endpoint = "".concat(baseUrl, "/graphql");
    var variable = {
        "domain": location.host,
        "device": "WEB",
        "country": null,
        "language": getPreferredLanguage() || 'en'
    };
    var finalPayload = {
        "query": minifiedTveQuery,
        "variables": variable,
        "extensions": {
            "persistedQuery": {
                "version": 1,
                "sha256Hash": minifiedTveQuerySHA
            }
        }
    };
    try {
        return axios.post(endpoint, finalPayload)
            .then(function (response) {
            return getTveProviderList();
        })
            .catch(function (error) {
            if (error.response) {
                console.log(error.response.data);
            }
            else {
                console.log('Error', error.message);
            }
        });
    }
    catch (err) {
        console.error("GG", err);
    }
};
